import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { GetProductsRequestPost, Product, ProductsUtils } from '../../common';
import { ProductMetaTileComponent } from '../product-meta-tile/product-meta-tile.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { SlicePipe } from '@angular/common';
import { CurrencyPipe } from '../../../../lib/pipes/currency.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductTechnicalDataPipe } from '../../pipes/product-technical-data.pipe';

@Component({
    selector: 'ca-product-tile',
    templateUrl: './product-tile.component.html',
    styleUrls: ['./product-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ProductMetaTileComponent, MatButton, MatIcon, SlicePipe, CurrencyPipe, TranslatePipe, ProductTechnicalDataPipe]
})
export class ProductTileComponent {
    readonly placeholderImageSrc = ProductsUtils.placeholderImageSrc;
    product = input.required<Product>();
    languageCode = input.required<GetProductsRequestPost['languageCode']>();
    countryCode = input.required<GetProductsRequestPost['countryCode']>();
    isSelected = input<boolean>(false);
    allowedProductTypes = input<Product['productType'][]>();
    allowDifferentProductTypeSelection = input<boolean>(true);
    selectProduct = output<Product>();

    isDifferentProductType = computed(() => {
        if (this.allowDifferentProductTypeSelection()) return false;
        const allowedProductTypes = this.allowedProductTypes();
        if (!allowedProductTypes) return false;
        const product = this.product();
        return allowedProductTypes.length > 0 && !allowedProductTypes.includes(product.productType);
    });
}
